import { Component } from '@angular/core';

@Component({
  selector: 'app-centered-layout',
  standalone: false,
  templateUrl: './centered-layout.component.html',
  styleUrl: './centered-layout.component.sass',
})
export class CenteredLayoutComponent {

}
